export default "__VITE_ASSET__CGOqv09H__"